import { render, staticRenderFns } from "./NutrientAmountTable.vue?vue&type=template&id=492c6956&"
import script from "./NutrientAmountTable.vue?vue&type=script&lang=ts&"
export * from "./NutrientAmountTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports